import React from "react";

import { WithApolloClient } from "providers/WithApolloClient";
import { ProvideApolloV2Client } from "providers/WithApolloV2Client";
import { WithLoadingContext } from "providers/WithLoadingContext";
import WithEphemeralAppState from "providers/WithEphemeralAppState";

type Props = {
  children: React.ReactElement;
  graphqlUri: string;
};

const App: React.FunctionComponent<Props> = ({ children, graphqlUri }) => {
  return (
    <WithEphemeralAppState>
      <WithLoadingContext>
        <WithApolloClient graphqlUri={graphqlUri}>
          <ProvideApolloV2Client graphqlUri={graphqlUri}>
            {children}
          </ProvideApolloV2Client>
        </WithApolloClient>
      </WithLoadingContext>
    </WithEphemeralAppState>
  );
};

export default App;
